<template>
    <div v-if="loan && loan.ledger_status === 'two_failed_attempts'" class="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
        <div class="flex items-start">
            <div>
                <h3 class="text-lg font-semibold text-red-800 mb-2">‼️ Automatic Payments Temporarily Disabled</h3>
                <p class="text-red-700">
                    We noticed that two consecutive payments were not processed successfully. As a result, your automatic payments have been temporarily disabled for your protection.
                </p>
            </div>
        </div>

        <button
            @click="reactivateAutomaticPayments"
            type="button" 
            class="block w-full no-underline mt-4 bg-red-600 hover:bg-red-700 border border-red-700 rounded text-white text-center text-lg font-semibold py-3 transition-colors duration-200" 
            data-testid="reactivate-automatic-payments"
        >
            Reactivate Automatic Payments
        </button>

        <AppErrorPopup
            :show="showErrorPopup"
            :message="errorMessage"
            @close="closeErrorPopup"
        />
    </div>
</template>

<script>
import AppErrorPopup from "./AppErrorPopup";

export default {
    name: "LoanPaymentsDeactivated",
    components: {
        AppErrorPopup,
    },
    data() {
        return {
            showErrorPopup: false,
            errorMessage: '',
        };
    },
    mixins: [
        require('../mixins/InteractsWithLoans').default
    ],
    methods: {
        reactivateAutomaticPayments() {
            this.$http.post(`/account/loans/${this.loan.id}/reactivate-automatic-payments`)
                .then(response => {
                    this.loan.ledger_status = 'enabled';
                })
                .catch(error => {
                    this.errorMessage = error.response?.data?.message || "An error occurred while reactivating the payments.";
                    this.showErrorPopup = true;
                });
        },
        closeErrorPopup() {
            this.showErrorPopup = false;
            this.errorMessage = '';
        },
    },
};
</script>